// src/data/questions.ts
import Papa, { ParseResult, ParseError } from 'papaparse';
import { Question } from '../types';

interface QuestionRow {
  id: string;
  axis: string;
  text: string;
  option1: string;
  score1: string;
  isPenalty1: string;
  option2: string;
  score2: string;
  isPenalty2: string;
  option3: string;
  score3: string;
  isPenalty3: string;
  option4: string;
  score4: string;
  isPenalty4: string;
}

export async function loadQuestions(): Promise<Question[]> {
  try {
    const response = await fetch('/questions/questions_junior.csv');
    const csvText = await response.text();
    
    return new Promise<Question[]>((resolve, reject) => {
      Papa.parse<QuestionRow>(csvText, {
        header: true,
        skipEmptyLines: true,
        complete: (results) => {
          const questions: Question[] = results.data.map((row) => {
            // 選択肢とスコアの抽出
            const scores: { [key: string]: number } = {};
            const penaltyAnswer: string[] = [];
            
            // 4つの選択肢を処理
            for (let i = 1; i <= 4; i++) {
              const option = row[`option${i}` as keyof QuestionRow];
              const score = Number(row[`score${i}` as keyof QuestionRow]);
              const isPenalty = Number(row[`isPenalty${i}` as keyof QuestionRow]) === 1;
              
              if (option && !isNaN(score)) {
                scores[option] = score;
                if (isPenalty) {
                  penaltyAnswer.push(option);
                }
              }
            }

            return {
              id: Number(row.id),
              axis: row.axis as '横' | '縦',
              text: row.text,
              scores,
              penaltyAnswer
            };
          });

          resolve(questions);
        },
        error: (error: Error) => {
          reject(new Error(`CSV parsing failed: ${error.message}`));
        }
      });
    });
  } catch (error) {
    if (error instanceof Error) {
      throw new Error(`Failed to load questions: ${error.message}`);
    } else {
      throw new Error('Failed to load questions: Unknown error');
    }
  }
}
